/** Botón para alternar entre modo claro y oscuro. */

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import { useTranslation } from 'react-i18next'

import { useTema } from '../contexto/Tema'

export function AlternarTema({ color = 'inherit' }: { color?: 'inherit' | 'primary' }) {
  const { modo, alternar } = useTema()
  const { t } = useTranslation()
  const etiqueta = modo === 'dark' ? t('app.temaClaro') : t('app.temaOscuro')
  return (
    <Tooltip title={etiqueta}>
      <IconButton onClick={alternar} color={color} aria-label={etiqueta} size="large">
        {modo === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  )
}
